import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import TabNavigation from '../components/TabNavigation';
import NewTrainingPage from './NewTrainingPage';
import QuickTrainPage from './QuickTrainPage';
import '../styles/dashboard-pages.css';

const TrainingPage: React.FC = () => {
  const tabs = [
    { path: '/dashboard/training/new', label: 'New Training', icon: '🆕' },
    { path: '/dashboard/training/quick', label: 'Quick Train', icon: '⚡' },
  ];

  return (
    <div className="dashboard-page">
      <div className="page-header">
        <h1>Training</h1>
        <p>Create and manage your neural network training jobs</p>
      </div>
      
      <TabNavigation tabs={tabs} basePath="/dashboard/training" />
      
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard/training/new" replace />} />
        <Route path="/new" element={<NewTrainingPage />} />
        <Route path="/quick" element={<QuickTrainPage />} />
      </Routes>
    </div>
  );
};

export default TrainingPage;

